import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import AuthService from "services/auth.service";
import UserService from "services/user.service";
import AssistantService from "services/assistant.service";

const SelectLocation = (props) => {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  const [panels, setPanels] = useState([]);
  const [location, setLocation] = useState(null);
  const currentUser = AuthService.getCurrentUser();
  const practiceLocation = AuthService.getPracticeLocation();
  const [displayError, setDisplayError] = useState(false);
  const currentAssistant = AuthService.getCurrentAssistant();
  const [locationIds, setLocationIds] = useState([]);
  const [locationList, setLocationList] = useState(null);
  const [loading, setLoading] = useState(true);

  const logOut = () => {
    AuthService.logout();
    window.location.replace("/eb/login");
  };

  useEffect(() => {
    if (!practiceLocation) {
      const fetchData = async () => {
        try {
          if (currentAssistant) {
            const data = await AssistantService.profile(currentAssistant.id);
            setLocationIds(data.practice_location_ids);
          }

          const data = await UserService.profile(currentUser.id);
          setLocationList(data.locations || []);
          // if (!data.locations || data.locations.length === 0) {
          //   window.location.replace("/eb");
          // }
        } catch (error) {
          if (error.response?.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    } else {
      setLoading(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let allowedLocations = locationList;
    if (allowedLocations === null) return;

    if (currentAssistant) {
      allowedLocations = locationList.filter((hash) =>
        locationIds.includes(hash.id)
      );
    }

    if (allowedLocations.length === 1) {
      setLocation(allowedLocations[0]);
    } else if (allowedLocations.length === 0) {
      setDisplayError(true);
    } else {
      setDisplayError(false);
      const panelLocations = allowedLocations.map((hash, index) => (
        <div key={index}>
          <button
            className="select-entitlement-btn btn btn-outline-grey text-dark rounded-pill py-2 px-6 mb-4 w-em-45"
            onClick={() => setLocation(hash)}
          >
            <div className="text-left font-size-7">{hash.name}</div>
          </button>
        </div>
      ));
      setPanels(panelLocations);
    }
  }, [locationIds, locationList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!location) {
      localStorage.setItem("practice_location", JSON.stringify(location));
      window.location.replace("/eb/");
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div id="main-content-target">
      <h2 className="text-danger">Employee Benefits</h2>

      <Modal
        show={show}
        onHide={handleClose}
        keyboard={false}
        size="lg"
        centered
        backdrop="static"
      >
        {!loading && !displayError && (
          <Modal.Header className="d-block">
            <h3 className="text-center">
              Which Practice Location Are You In Today?
            </h3>
          </Modal.Header>
        )}

        <Modal.Body className="d-block text-center">
          {loading ? (
            <>
              <div className="img-msg-container py-20">
                <span className="img-msg"></span>
                <span className="text-grey">Loading...</span>
              </div>
            </>
          ) : !displayError ? (
            <>
              <p className="text-center text-grey mb-10">
                Select your current practice location.
              </p>
              {panels}
            </>
          ) : (
            <>
              <p className="text-center text-grey mb-10">
                No practice locations found.
                <br />
                Please contact your administrator to rectify this issue.
              </p>
              <button
                className="btn btn-danger text-white rounded-pill py-3 px-20"
                onClick={logOut}
              >
                Log Out
              </button>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SelectLocation;
